import { ReduxState } from "../store";

export const selectOTP = (state: ReduxState) => state.forgetPassword.OTP;
export const selectUsername = (state: ReduxState) => state.forgetPassword.username;
export const selectForgetPasswordStep = (state: ReduxState) => state.forgetPassword.step;
export const selectNewPassword = (state: ReduxState) => state.forgetPassword.newPassword;
export const selectFetchStatus = (state: ReduxState) => state.forgetPassword.fetchStatus;
